<!-- 车场交易数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {

            },
            responseCode: {
                    "data": {

                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 查询运营商或车牌欠费记录",
                t_url: this.commonUrls.test+"getCarArrearRecordList",
                p_url: this.commonUrls.prod+"getCarArrearRecordList",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'operatorId', info2: '否', info3: 'Integer', info4: '运营商Id' },
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '车场编码' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'entranceType', info2: '否', info3: 'Integer', info4: '进出场类型,1:进场,2:离场' },
                      { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始，默认1' },
                      { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多1000条，默认10' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'int', info4: '总数' },
                        { info1: 'isShowCar', info2: '是', info3: 'int', info4: '是否展示封闭停车场费用 0:不展示,1:展示' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
                        { info1: 'data', info2: '是', info3: 'List', info4: '记录列表' }
                        ]
                },{
                    titleName: 'data',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '否', info3: 'String', info4: '记录id' },
                        { info1: 'topBillCode', info2: '是', info3: 'String', info4: '停车流水号' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'arrearRealValue', info2: '是', info3: 'BigDecimal', info4: '当前欠费金额' },
                        { info1: 'forcePay', info2: '否', info3: 'int', info4: '强制补缴，0不支持，1支持' },
                        { info1: 'arrearMarkTime', info2: '否', info3: 'String', info4: '欠费标记时间 yyyyMMddHHmmss' },
                        { info1: 'enterTime', info2: '否', info3: 'String', info4: '进场时间 yyyyMMddHHmmss' },
                        { info1: 'leaveTime', info2: '否', info3: 'String', info4: '离场时间 yyyyMMddHHmmss' },
                        { info1: 'enterCarImageUrl', info2: '否', info3: 'String', info4: '进出图片' },
                        { info1: 'timeStr', info2: '否', info3: 'String', info4: '停车时长' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/getCarArrearRecordList.vue